module.exports = __webpack_public_path__ + "img/train-subway-tunnel.5f53ad3a.svg";